import { render, staticRenderFns } from "./product_push_log_dialog.vue?vue&type=template&id=2dc52909&scoped=true"
import script from "./product_push_log_dialog.vue?vue&type=script&lang=js"
export * from "./product_push_log_dialog.vue?vue&type=script&lang=js"
import style0 from "./product_push_log_dialog.vue?vue&type=style&index=0&id=2dc52909&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc52909",
  null
  
)

export default component.exports